import { Pipe, PipeTransform } from '@angular/core';
import { SupplierProfile } from '../models/supplier-profile';

@Pipe({
  standalone: false,
  name: 'supplierFilter',
})
export class SupplierFilterPipe implements PipeTransform {
  transform(
    suppliers: SupplierProfile[] | null,
    search?: string
  ): SupplierProfile[] {
    if (search === undefined) return suppliers!;

    var filterResult = suppliers!.filter((data: any) =>
      data.supplierIdentity.toLowerCase().includes(search?.toLowerCase())
    );
    return filterResult;
  }
}

